import { IonAlert, IonButtons, IonLoading } from "@ionic/react";
import { useContext, useState } from "react";
import useSaveSVG from "../../../../hooks/useSaveSvg";
import AppContext from "../../../../contexts/AppContext";
import "./style.css";
import { resetBulkConversionState } from "../../../../redux/slices/BulkConversion";
import { useAppDispatch } from "../../../../redux/store";

const Close = ({
  changesMade,
  svgJoined,
  currentFile,
  children,
  styles,
  setIsCloseHovered,
  onStitchSave,
  // Replaces the built-in save when the open file isn't the user's to write to —
  // a community design being previewed. Without this, saveSVG would fall into
  // its "no Storage ref yet" branch and quietly upload the design into their
  // account with no attribution, which is the decision the preview exists to
  // put in their hands. Should resolve falsy if the save didn't happen.
  saveOverride,
  saveLabel = "Save Changes",
}) => {
  const { setSvgStore, setPendingEmbroideryMode } = useContext(AppContext);
  const dispatch = useAppDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const { saveSVG, loading, error, setError, setLoading } = useSaveSVG(
    svgJoined,
    currentFile
  );

  const closeEditor = () => {
    setSvgStore(undefined);
    if (setPendingEmbroideryMode) setPendingEmbroideryMode(false);
  };

  const handleSave = async () => {
    if (saveOverride) {
      if (await saveOverride()) closeEditor();
      return;
    }
    const success = await saveSVG();
    if (success) {
      await onStitchSave?.();
      closeEditor();
    }
  };

  const handleClose = () => {
    if (!changesMade) {
      closeEditor();
    } else {
      setShowAlert(true);
    }
    dispatch(resetBulkConversionState());
  };

  return (
    <>
      <IonButtons
        onClick={handleClose}
        style={{ ...styles, cursor: "pointer" }}
        onMouseEnter={() => setIsCloseHovered && setIsCloseHovered(true)}
        onMouseLeave={() => setIsCloseHovered && setIsCloseHovered(false)}
      >
        {children}
      </IonButtons>
      <IonAlert
        isOpen={showAlert}
        onDidDismiss={() => setShowAlert(false)}
        header="Do you want to save?"
        subHeader="You will loose changes if you don’t save the progress"
        cssClass="close-alert"
        buttons={[
          {
            text: "Don't Save",
            cssClass: "alert-button-dont-save alert-button",
            handler: closeEditor,
          },
          {
            text: saveLabel,
            cssClass: "alert-button-save alert-button",
            handler: handleSave,
          },
        ]}
      />
      {error && (
        <IonAlert
          isOpen={!!error}
          onDidDismiss={() => setError(null)}
          header="Error"
          subHeader="An error occurred while saving"
          buttons={["OK"]}
        />
      )}
      <IonLoading
        isOpen={loading}
        message={"Saving..."}
        onDidDismiss={() => setLoading(false)}
      />
    </>
  );
};

export default Close;
